import React from "react";
import Moment from "react-moment";

function DateTimeFormat(props) {
  return <Moment format="llll">{props.children}</Moment>;
}

export default DateTimeFormat;
